import type { CreateUpdateCashierFormOutput } from "@/composables/forms/useCreateUpdateCashierForm"
import { api } from "@/api"
import { queryClient } from "@/queryClient"

export const updateCashier = async (
  cashierId: string,
  params: CreateUpdateCashierFormOutput
) => {
  await api.put(`/cashiers/${cashierId}`, {
    body: params,
  })
  queryClient.invalidateQueries({
    queryKey: [BASE_CASHIERS_QUERY_KEY],
  })
}
